import './view-nav-float-button.css';
import { h } from 'preact';

export default function ViewNavFloatButton({ id, name, isSelected, onClick }) {
	function handleClick() {
		if (typeof onClick === 'function') {
			onClick(id);
		}
	}

	return (
		<button class={'view-nav-float-button' + (isSelected ? ' is-selected' : '')} onClick={handleClick}>
			{name}
		</button>
	);
}
